import { z } from "zod";

const optionalNumberNull = z.coerce.number().int().nullable().optional();
const optionalDecimalNull = z.coerce.number().nullable().optional(); // Para decimal(18, 2)
const optionalBool = z.coerce.boolean().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);

const requiredInt = z.coerce
  .number({ invalid_type_error: "Campo obrigatório", required_error: "Campo obrigatório" })
  .int()
  .min(1, "Selecione uma opção válida"); 


const requiredDecimal = z.coerce
  .number({ invalid_type_error: "Valor inválido", required_error: "Campo obrigatório" })
  .min(0.0001, "O valor deve ser maior que zero");

export const ItemMedicaoTerceirizacaoSchema = z.object({
  IdItemMedicaoTerceirizacao: z.number().int().default(0),
  IdMedicaoTerceirizacao: optionalNumberNull,
  IdProdutoServico: requiredInt,
  IdSubconta: optionalNumberNull,
  Detalhamento: optionalString, 
  Quantidade: requiredDecimal,    
  ValorUnitario: requiredDecimal, 
  ValorTotal: optionalDecimalNull, 


  //EXTRA
  CheckBoxServico: optionalBool,
});

export type ItemMedicaoTerceirizacaoForm = z.infer<typeof ItemMedicaoTerceirizacaoSchema>;